var React = require('react');

function Magnifier (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M23.608 23.707a.994.994 0 0 1-1.409 0l-7.653-7.682A8.898 8.898 0 0 1 8.956 18C4.012 18-.011 13.963-.011 9.001-.011 4.038 4.012 0 8.956 0c4.944 0 8.966 4.038 8.966 9.001a8.97 8.97 0 0 1-1.967 5.61l7.653 7.682c.389.39.389 1.024 0 1.414zM8.956 2C5.11 2 1.982 5.141 1.982 9.001 1.982 12.86 5.11 16 8.956 16c3.845 0 6.974-3.14 6.974-6.999C15.93 5.141 12.801 2 8.956 2z"}));
}

Magnifier.displayName = "Magnifier";

Magnifier.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 23.906 24"};

module.exports = Magnifier;

Magnifier.default = Magnifier;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/magnifier.svg
// module id = 1276
// module chunks = 0